// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file transportation/v1/driver_certification.proto (package transportation.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Base, ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file transportation/v1/driver_certification.proto.
 */
export const file_transportation_v1_driver_certification: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_types]);

/**
 * DriverCertification message definition
 *
 * @generated from message transportation.v1.DriverCertification
 */
export type DriverCertification = Message<"transportation.v1.DriverCertification"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID driver_id = 2;
   */
  driverId?: ID;

  /**
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: string number = 4;
   */
  number: string;

  /**
   * @generated from field: google.protobuf.Timestamp issued_date = 5;
   */
  issuedDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expiration_date = 6;
   */
  expirationDate?: Timestamp;

  /**
   * @generated from field: string issuing_body = 7;
   */
  issuingBody: string;

  /**
   * @generated from field: types.Base base = 8;
   */
  base?: Base;
};

/**
 * Describes the message transportation.v1.DriverCertification.
 * Use `create(DriverCertificationSchema)` to create a new message.
 */
export const DriverCertificationSchema: GenMessage<DriverCertification> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_certification, 0);

/**
 * Request/Response messages for DriverCertification queries
 *
 * @generated from message transportation.v1.GetDriverCertificationRequest
 */
export type GetDriverCertificationRequest = Message<"transportation.v1.GetDriverCertificationRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.GetDriverCertificationRequest.
 * Use `create(GetDriverCertificationRequestSchema)` to create a new message.
 */
export const GetDriverCertificationRequestSchema: GenMessage<GetDriverCertificationRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_certification, 1);

/**
 * @generated from message transportation.v1.GetDriverCertificationResponse
 */
export type GetDriverCertificationResponse = Message<"transportation.v1.GetDriverCertificationResponse"> & {
  /**
   * @generated from field: transportation.v1.DriverCertification driver_certification = 1;
   */
  driverCertification?: DriverCertification;
};

/**
 * Describes the message transportation.v1.GetDriverCertificationResponse.
 * Use `create(GetDriverCertificationResponseSchema)` to create a new message.
 */
export const GetDriverCertificationResponseSchema: GenMessage<GetDriverCertificationResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_certification, 2);

/**
 * @generated from message transportation.v1.ListDriverCertificationsRequest
 */
export type ListDriverCertificationsRequest = Message<"transportation.v1.ListDriverCertificationsRequest"> & {
  /**
   * @generated from field: transportation.v1.ListDriverCertificationsFilter filter = 1;
   */
  filter?: ListDriverCertificationsFilter;

  /**
   * @generated from field: repeated transportation.v1.DriverCertificationSortOption sorting = 2;
   */
  sorting: DriverCertificationSortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message transportation.v1.ListDriverCertificationsRequest.
 * Use `create(ListDriverCertificationsRequestSchema)` to create a new message.
 */
export const ListDriverCertificationsRequestSchema: GenMessage<ListDriverCertificationsRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_certification, 3);

/**
 * @generated from message transportation.v1.ListDriverCertificationsFilter
 */
export type ListDriverCertificationsFilter = Message<"transportation.v1.ListDriverCertificationsFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: google.protobuf.StringValue driver_id = 2;
   */
  driverId?: string;

  /**
   * @generated from field: google.protobuf.StringValue search_term = 3;
   */
  searchTerm?: string;

  /**
   * @generated from field: types.ID organization_id = 4;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.ListDriverCertificationsFilter.
 * Use `create(ListDriverCertificationsFilterSchema)` to create a new message.
 */
export const ListDriverCertificationsFilterSchema: GenMessage<ListDriverCertificationsFilter> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_certification, 4);

/**
 * @generated from message transportation.v1.ListDriverCertificationsResponse
 */
export type ListDriverCertificationsResponse = Message<"transportation.v1.ListDriverCertificationsResponse"> & {
  /**
   * @generated from field: repeated transportation.v1.DriverCertification driver_certifications = 1;
   */
  driverCertifications: DriverCertification[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message transportation.v1.ListDriverCertificationsResponse.
 * Use `create(ListDriverCertificationsResponseSchema)` to create a new message.
 */
export const ListDriverCertificationsResponseSchema: GenMessage<ListDriverCertificationsResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_certification, 5);

/**
 * Command messages
 *
 * @generated from message transportation.v1.CreateDriverCertificationRequest
 */
export type CreateDriverCertificationRequest = Message<"transportation.v1.CreateDriverCertificationRequest"> & {
  /**
   * @generated from field: transportation.v1.DriverCertificationInput input = 1;
   */
  input?: DriverCertificationInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.CreateDriverCertificationRequest.
 * Use `create(CreateDriverCertificationRequestSchema)` to create a new message.
 */
export const CreateDriverCertificationRequestSchema: GenMessage<CreateDriverCertificationRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_certification, 6);

/**
 * @generated from message transportation.v1.CreateDriverCertificationResponse
 */
export type CreateDriverCertificationResponse = Message<"transportation.v1.CreateDriverCertificationResponse"> & {
  /**
   * @generated from field: transportation.v1.DriverCertification driver_certification = 1;
   */
  driverCertification?: DriverCertification;
};

/**
 * Describes the message transportation.v1.CreateDriverCertificationResponse.
 * Use `create(CreateDriverCertificationResponseSchema)` to create a new message.
 */
export const CreateDriverCertificationResponseSchema: GenMessage<CreateDriverCertificationResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_certification, 7);

/**
 * @generated from message transportation.v1.UpdateDriverCertificationRequest
 */
export type UpdateDriverCertificationRequest = Message<"transportation.v1.UpdateDriverCertificationRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: transportation.v1.DriverCertificationUpdateInput input = 2;
   */
  input?: DriverCertificationUpdateInput;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.UpdateDriverCertificationRequest.
 * Use `create(UpdateDriverCertificationRequestSchema)` to create a new message.
 */
export const UpdateDriverCertificationRequestSchema: GenMessage<UpdateDriverCertificationRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_certification, 8);

/**
 * @generated from message transportation.v1.UpdateDriverCertificationResponse
 */
export type UpdateDriverCertificationResponse = Message<"transportation.v1.UpdateDriverCertificationResponse"> & {
  /**
   * @generated from field: transportation.v1.DriverCertification driver_certification = 1;
   */
  driverCertification?: DriverCertification;
};

/**
 * Describes the message transportation.v1.UpdateDriverCertificationResponse.
 * Use `create(UpdateDriverCertificationResponseSchema)` to create a new message.
 */
export const UpdateDriverCertificationResponseSchema: GenMessage<UpdateDriverCertificationResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_certification, 9);

/**
 * @generated from message transportation.v1.DeleteDriverCertificationRequest
 */
export type DeleteDriverCertificationRequest = Message<"transportation.v1.DeleteDriverCertificationRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.DeleteDriverCertificationRequest.
 * Use `create(DeleteDriverCertificationRequestSchema)` to create a new message.
 */
export const DeleteDriverCertificationRequestSchema: GenMessage<DeleteDriverCertificationRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_certification, 10);

/**
 * Input messages
 *
 * @generated from message transportation.v1.DriverCertificationInput
 */
export type DriverCertificationInput = Message<"transportation.v1.DriverCertificationInput"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID driver_id = 2;
   */
  driverId?: ID;

  /**
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: string number = 4;
   */
  number: string;

  /**
   * @generated from field: google.protobuf.Timestamp issued_date = 5;
   */
  issuedDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expiration_date = 6;
   */
  expirationDate?: Timestamp;

  /**
   * @generated from field: string issuing_body = 7;
   */
  issuingBody: string;
};

/**
 * Describes the message transportation.v1.DriverCertificationInput.
 * Use `create(DriverCertificationInputSchema)` to create a new message.
 */
export const DriverCertificationInputSchema: GenMessage<DriverCertificationInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_certification, 11);

/**
 * @generated from message transportation.v1.DriverCertificationUpdateInput
 */
export type DriverCertificationUpdateInput = Message<"transportation.v1.DriverCertificationUpdateInput"> & {
  /**
   * @generated from field: types.ID driver_id = 1;
   */
  driverId?: ID;

  /**
   * @generated from field: google.protobuf.StringValue type = 2;
   */
  type?: string;

  /**
   * @generated from field: google.protobuf.StringValue number = 3;
   */
  number?: string;

  /**
   * @generated from field: google.protobuf.Timestamp issued_date = 4;
   */
  issuedDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expiration_date = 5;
   */
  expirationDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue issuing_body = 6;
   */
  issuingBody?: string;
};

/**
 * Describes the message transportation.v1.DriverCertificationUpdateInput.
 * Use `create(DriverCertificationUpdateInputSchema)` to create a new message.
 */
export const DriverCertificationUpdateInputSchema: GenMessage<DriverCertificationUpdateInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_certification, 12);

/**
 * @generated from enum transportation.v1.DriverCertificationSortOption
 */
export enum DriverCertificationSortOption {
  /**
   * @generated from enum value: DRIVER_CERTIFICATION_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DRIVER_CERTIFICATION_SORT_OPTION_TYPE_ASC = 1;
   */
  TYPE_ASC = 1,

  /**
   * @generated from enum value: DRIVER_CERTIFICATION_SORT_OPTION_TYPE_DESC = 2;
   */
  TYPE_DESC = 2,

  /**
   * @generated from enum value: DRIVER_CERTIFICATION_SORT_OPTION_EXPIRATION_DATE_ASC = 3;
   */
  EXPIRATION_DATE_ASC = 3,

  /**
   * @generated from enum value: DRIVER_CERTIFICATION_SORT_OPTION_EXPIRATION_DATE_DESC = 4;
   */
  EXPIRATION_DATE_DESC = 4,

  /**
   * @generated from enum value: DRIVER_CERTIFICATION_SORT_OPTION_CREATED_AT_ASC = 5;
   */
  CREATED_AT_ASC = 5,

  /**
   * @generated from enum value: DRIVER_CERTIFICATION_SORT_OPTION_CREATED_AT_DESC = 6;
   */
  CREATED_AT_DESC = 6,
}

/**
 * Describes the enum transportation.v1.DriverCertificationSortOption.
 */
export const DriverCertificationSortOptionSchema: GenEnum<DriverCertificationSortOption> = /*@__PURE__*/
  enumDesc(file_transportation_v1_driver_certification, 0);

/**
 * Services
 *
 * @generated from service transportation.v1.DriverCertificationQueriesService
 */
export const DriverCertificationQueriesService: GenService<{
  /**
   * @generated from rpc transportation.v1.DriverCertificationQueriesService.GetDriverCertification
   */
  getDriverCertification: {
    methodKind: "unary";
    input: typeof GetDriverCertificationRequestSchema;
    output: typeof GetDriverCertificationResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.DriverCertificationQueriesService.ListDriverCertifications
   */
  listDriverCertifications: {
    methodKind: "unary";
    input: typeof ListDriverCertificationsRequestSchema;
    output: typeof ListDriverCertificationsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_transportation_v1_driver_certification, 0);

/**
 * @generated from service transportation.v1.DriverCertificationCommandsService
 */
export const DriverCertificationCommandsService: GenService<{
  /**
   * @generated from rpc transportation.v1.DriverCertificationCommandsService.CreateDriverCertification
   */
  createDriverCertification: {
    methodKind: "unary";
    input: typeof CreateDriverCertificationRequestSchema;
    output: typeof CreateDriverCertificationResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.DriverCertificationCommandsService.UpdateDriverCertification
   */
  updateDriverCertification: {
    methodKind: "unary";
    input: typeof UpdateDriverCertificationRequestSchema;
    output: typeof UpdateDriverCertificationResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.DriverCertificationCommandsService.DeleteDriverCertification
   */
  deleteDriverCertification: {
    methodKind: "unary";
    input: typeof DeleteDriverCertificationRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_transportation_v1_driver_certification, 1);

